// extracted by mini-css-extract-plugin
module.exports = {"Auth":"_2N4mhcnGbW7JC6z-s6bKrq","AuthForm":"w8QpKPDbcPFePjv5OG7Lm"};